
import React, { useContext, useEffect, useState } from 'react'
import { SelectOption } from '../../../shared/components/input/SelectOption'
import TextInputWithLabelInline from '../../../shared/components/input/TextInputWithLabelInline'
import { ErrorBoundary } from 'react-error-boundary'
import _, { update } from 'lodash'
import Logger from '../../../shared/services/Logger'
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as constant from '../../../shared/util/constant'
import { Container, Nav, Tab } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import * as label from '../../../shared/util/label'
import { Card, Collapse } from 'react-bootstrap'
import { Row } from "react-bootstrap";
import { Button, Column, Checkbox } from "../../../components";
import DropDownWithLabelInline from "../../../shared/components/input/DropDownWithLabelInline";
import { CustomerScreentLables as cstScrLables } from "../../../shared/util/label";
import { userSetupUtils } from '../../utils/UserSetupUtils'
import EmployeeSetupService from '../service/EmployeeSetupService'
import { AbilityContext } from '../../../shared/abilities/AbilityContext'

import * as tableId from '../../../shared/util/tableConstant'

import { useTable } from 'react-table';
import { table } from 'console'
import EmployeeSetupModel from '../../model/EmployeeSetupModel'
import UserDetailModel from '../../model/UserDetailModel'
import { useDispatch, useSelector } from "react-redux";
import { EmployeeContext } from '../EmployeeContext'
import './../UserSetupMiniTabs.scss';

import { fetchUserDetails, FetchUserDetails } from '../../../shared/components/userContext-slice'

export interface IUserDetailView {
    relationships: SelectOption[],
    onFieldChange: (collectionPropName: string, collectionEntityIdentifierPropName: string, collectionEntityIdentifierValue: any, propName: string, value: string | Date | boolean) => void,
    // onDelete : (dependent : CustomerDependent) => void,
    formValidations: any,
    isEditable: boolean,
    isReset: boolean,
    setOpen: (key: string) => void;
    loadDataFlag: (key: boolean) => void;
}

const UserDetails: React.FunctionComponent<IUserDetailView> = ({ userdetail, setUserDetail, setOpen, loadDataFlag }) => {
    const dispatch = useDispatch()
    const ability = React.useContext(AbilityContext);
    const canUpdate = ability.can('update', constant.AdminSubject, constant.AdminScreenPrivileges.User_Setup);
    const canDelete = ability.can('delete', constant.AdminSubject, constant.AdminScreenPrivileges.User_Setup);
    const employeeDetailContext = React.useContext(EmployeeContext);
    useEffect(() => {
        setId(employeeDetailContext.id);
        setUserDetail(prevState => ({ ...prevState, id: employeeDetailContext.id }));
    }, [employeeDetailContext.id]);
    // const empDetailContext  = useContext(employeeDetailContext);
    // const userDetails: UserDetailModel = {
    //     id: employeeDetailContext.id,
    //     firstName: employeeDetailContext.firstName,
    //     lastName: employeeDetailContext.lastName,
    //     eMail: employeeDetailContext.email,
    //     roleId: '',
    //     isActive: false
    // }

    const employeeSetupService = new EmployeeSetupService()

    const [activeTab, setActiveTab] = useState('tab1');
    const history = useHistory();

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);

    };


    const [employeeStatusOptions, setEmployeeStatus] = useState<SelectOption[]>([]);
    const [agencyGroups, setAgencyGroups] = useState<SelectOption[]>([]);
    const [selectedAgencyGroup, setSelectedAgencyGroup] = useState([]);
    const [agencies, setAgencyList] = useState<SelectOption[]>([]);
    // const [userdetail, setUserDetail] = useState(userDetails);
    const [isEditable, setIsEditable] = useState(true);
    const [employeeList, setEmployeeList] = useState<SelectOption[]>([]);
    const [indicatorList, setIndicators] = useState<SelectOption[]>([]);
    const [roleList, setRoleList] = useState<SelectOption[]>([]);
    const [id, setId] = useState(employeeDetailContext.id);
    const [isActive, SetUserActive] = useState(false)
    const [savedData, setDataSaved] = useState(false);
    const [emailChange, setEmailChange] = useState(false);
    const userDetail = useSelector((state: any) => state.userContextSlice);
    
    useEffect(() => {
        //alert('called')

        userSetupUtils.getAppRoles(tableId.ROLE_APP_ID)?.then(res => {
            setRoleList(res)
        })
    }, []);



    useEffect(() => {
        if (selectedAgencyGroup) {
            userSetupUtils.getAgenciesByGroup(selectedAgencyGroup)?.then(res => {
                setAgencyList(res);
                // setEmployeeStatus(res)
            })
        }
    }, [selectedAgencyGroup]);

    const handleAgencyGroupChange = (newValue) => {
        setSelectedAgencyGroup(newValue);
    };
    const onEntityFieldChange = (propName: string, value: string | Date | boolean | number) => {
        setUserDetail({
            ...userdetail,
            [propName]: value,
        });

        // if (propName == 'firstName' || propName == 'lastName') {
        //     setEmployeeDetail(cst => {
        //         return {
        //         ...cst,
        //         displayName: (cst.firstName ? cst.firstName : '') + ' ' + (cst.lastName ? cst.lastName : ''),
        //         };
        //       });
        // }
    }

    const SaveUser = async () => {
        try {
            if (userdetail.id == constant.DEFAULT_GUID) {
                toast.error("Employee must be created for User", {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                let updatedUser = await employeeSetupService.SaveUser(userdetail);
                setDataSaved(true);
                toast.success("Saved Successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
            }

            // if (updatedEmployer) {
            //     userDetails.id = updatedEmployer;
            //     setUserDetail({
            //         ...userDetails
            //     });
            // }
            // else {
            //     toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
            //         position: toast.POSITION.TOP_RIGHT
            //     });
            // }
        }
        catch (e) {
            Logger.logError(constant.CUSTOMER_ERROR_WHILE_SAVING, e);
            toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const manageActiveToggle = (event) => {
        if (event.target.checked) {
            SetUserActive(true)
            onEntityFieldChange("isActive", event.target.checked)
        }
        else {
            SetUserActive(false)
            onEntityFieldChange("isActive", event.target.checked)

        }

    }

    const CancelEdit = () => {
        setOpen("0"); // Close accordion panel
        if (savedData) {
            loadDataFlag(true);
        }
        else {
            loadDataFlag(false);
        }
    };


     
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    useEffect(() => {
        if (isValidEmail(userdetail.email) && emailChange) {            
            fetchUserObjectId(userdetail.email);
            setEmailChange(false);
        }
    }, [emailChange])    

    const pageSizeOptions: SelectOption[] = [
        { label: "10", value: "10" },
        { label: "20", value: "20" },
        { label: "50", value: "50" }
    ];

    
    const fetchUserObjectId = async (email) => {
    try {
        const objectId = await userSetupUtils.getUserObjectIdByEmail(email);
        setUserDetail((prevState) => ({ ...prevState, objectId }));      
    } catch (error) {
        Logger.logError(constant.UserSetup.ERROR_FETCH_OBJECT_ID, error);
        toast.error(constant.UserSetup.ERROR_FETCH_OBJECT_ID, {
            position: toast.POSITION.TOP_RIGHT
        });
        setUserDetail((prevState) => ({ ...prevState, objectId:"" }));  
    }
    };

    const pageSize = Number(userdetail.pageSize);
    useEffect(() => {
        if (!userdetail.pageSize && pageSizeOptions.length > 0) {
            onEntityFieldChange('pageSize', pageSizeOptions[0].value);
        }
    }, []);

    return (



        <Container fluid>
            <Row>
                <Column lg={6} md={6}>&nbsp;</Column>
                <Column lg={6} md={6}>&nbsp;</Column>
            </Row>


            <Row className='row-margin'>
                <Column lg={3} md={3}
                    className={''}>
                    <TextInputWithLabelInline
                        name='firstName'
                        label={cstScrLables.FIRST_NAME}
                        placeholder={'First Name'}
                        value={userdetail.firstName ?? employeeDetailContext.firstName}
                        onChange={(event) => onEntityFieldChange('firstName', event.currentTarget.value)}
                        isEditable={true}
                        type='text'
                        labelClass='inlineLable'
                        lglabel={4}
                        mdlabel={4}
                        isRequired
                        lgText={8}
                        mdText={8}
                        maxLength={60}
                        tabIndex={1}
                        // isInvalid={formValidation['firstName']?.isValid == false}
                        // invalidWarning={formValidation['firstName']?.warningText}
                        className='texbox-input'>
                    </TextInputWithLabelInline>
                </Column>
            </Row>
            <Row  className='row-margin'>
                <Column lg={3} md={3}>
                    <TextInputWithLabelInline
                        name='lastName'
                        label={cstScrLables.LAST_NAME}
                        placeholder={'Last Name'}
                        value={userdetail.lastName ?? employeeDetailContext.lastName}
                        onChange={(event) => onEntityFieldChange('lastName', event.currentTarget.value)}
                        isEditable={true}
                        type='text'
                        labelClass='inlineLable'
                        lglabel={4}
                        mdlabel={4}
                        isRequired
                        lgText={8}
                        mdText={8}
                        maxLength={60}
                        tabIndex={2}
                        // isInvalid={formValidation['firstName']?.isValid == false}
                        // invalidWarning={formValidation['firstName']?.warningText}
                        className='texbox-input'>
                    </TextInputWithLabelInline>
                </Column>
            </Row>
            <Row  className='row-margin'>
                <Column lg={3} md={3}>
                    <TextInputWithLabelInline
                        name='eMail'
                        label={'Email'}
                        placeholder={'Email'}
                        value={userdetail.email ?? employeeDetailContext.email}
                        onChange={(event) => onEntityFieldChange('email', event.currentTarget.value)}
                        isEditable={true}
                        type='text'
                        labelClass='inlineLable'
                        lglabel={4}
                        mdlabel={4}
                        isRequired
                        lgText={8}
                        mdText={8}
                        maxLength={60}
                        onBlur={()=>setEmailChange(true)}
                        tabIndex={3}
                        // isInvalid={formValidation['firstName']?.isValid == false}
                        // invalidWarning={formValidation['firstName']?.warningText}
                        className='texbox-input'>
                    </TextInputWithLabelInline>
                </Column>
            </Row>
            <Row className='row-margin'>
                <Column lg={3} md={3}>
                    <DropDownWithLabelInline
                        id='preferenceId'
                        label='Grid Page Size'
                        options={pageSizeOptions}
                        defaultSelected={pageSizeOptions?.filter(({ value }) => value === String(userdetail.pageSize))}
                        inputProps={{ className: 'inputStyle cstFilterInput texbox-input' }}
                        onChange={
                            (values) => {
                                onEntityFieldChange('pageSize', Number(values[0]))
                            }
                        }
                        labelSize={4}
                        dropDownSize={8}
                        dropdownDivClass={''}
                        labelClass='inlineLable'
                        isRequired
                        // disabled ={!props.isEditable}
                        multiple={false}
                        tabIndex={4}
                        showAsFloatingLabel={false}
                    />
                </Column>
            </Row>
            <Row className='row-margin'>
                <Column lg={3} md={3}>
                    <DropDownWithLabelInline
                        id='roleId'
                        label='Role'
                        options={roleList}
                        defaultSelected={roleList?.filter(({ value }) => value === userdetail.roleId)}
                        inputProps={{ className: 'inputStyle cstFilterInput texbox-input' }}
                        onChange={
                            (values) => {
                                onEntityFieldChange('roleId', values[0])
                            }
                        }
                        labelSize={4}
                        dropDownSize={8}
                        dropdownDivClass={''}
                        labelClass='inlineLable'
                        isRequired
                        // disabled ={!props.isEditable}
                        multiple={false}
                        tabIndex={5}
                        showAsFloatingLabel={false}
                    />
                </Column>
            </Row>
            <Row className='row-margin'>
                <Column lg={3} md={3}>
                    <TextInputWithLabelInline
                        name='objectId'
                        label={'Object Id'}
                        placeholder={'Object Id'}
                        value={userdetail.objectId ?? ""}
                        onChange={(event) => onEntityFieldChange('objectId', event.currentTarget.value)}
                        isEditable={false}
                        type='text'
                        labelClass='inlineLable'
                        lglabel={4}
                        mdlabel={4}
                        isRequired
                        lgText={8}
                        mdText={8}
                        maxLength={60}
                        // isInvalid={formValidation['firstName']?.isValid == false}
                        // invalidWarning={formValidation['firstName']?.warningText}
                        className='texbox-input'>
                    </TextInputWithLabelInline>
                </Column>
            </Row>
            <Row className='row-margin'>
                <Column md={1} lg={1}>

                </Column>
                <Column md={6} lg={6} className='paddingTop1 cstCheckbox'>
                    <Checkbox
                        id='isActive'
                        label={'Active'}
                        labelClassName='inlineLable'
                        checked={userdetail.isActive}
                        onChange={(event) => manageActiveToggle(event)}
                        tabIndex='11'
                        inline />
                </Column>
            </Row>

            <Row className='row-margin'>
                <Column lg={12} md={12}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <Button
                                className='btn btn-outline-primary'
                                key="cancel-btn"
                                onClick={() => CancelEdit()}
                                tabIndex={20}
                                id="btnCancel"
                                color='tertiary'
                                outlined={true}
                                disabled={false}
                            >
                                {label.CLOSE.toLocaleUpperCase()}
                            </Button>
                        </div>
                        <div>
                            <Button
                                className='btn btn-outline- me-3'
                                key="delete-btn"
                                onClick={() => EditCustomer()}
                                tabIndex={21}
                                id="btnEdit"
                                color='secondary'
                                disabled={!canDelete}
                                outlined={true}
                            >
                                {'DELETE'}
                            </Button>
                            <Button
                                className='btn btn-primary'
                                key="save-btn"
                                onClick={() => SaveUser()}
                                tabIndex={21}
                                id="btnAddCustomer"
                                disabled={!canUpdate}
                                color='primary'
                            >
                                {label.SAVE.toLocaleUpperCase()}
                            </Button>
                        </div>
                    </div>
                </Column>
            </Row>

        </Container>
    );
};
export default UserDetails;